import React, { useMemo, useEffect } from 'react'
import {
  Switch, Route, useRouteMatch, useHistory
} from 'react-router-dom'

import clsx from 'clsx'
import PropTypes from 'prop-types'

import findIndex from 'lodash/findIndex'
import first from 'lodash/first'
import get from 'lodash/get'
import map from 'lodash/map'

import AppBar from '@material-ui/core/AppBar'
import { useTheme, withStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import useMediaQuery from '@material-ui/core/useMediaQuery'


import colors from '@galo-monitor/styles/colors'

import useStyles from './styles'
import TabPanel from './TabPanel'

const StyledTab = withStyles({
  root: {
    color: colors.primary
  },
  wrapper: {
    textTransform: 'none'
  },
  textColorInherit: {
    color: colors.darkGrey3
  },
  selected: {
    color: colors.primary
  }
})(Tab)

function a11yProps(id, index) {
  return {
    id: `${ id }-tab-${ index }`,
    'aria-controls': `${ id }-tabpanel-${ index }`
  }
}

const TabsPanelRoutes = (props) => {
  const { itens } = props

  const classes = useStyles()

  const { path } = useRouteMatch()
  const history = useHistory()

  const theme = useTheme()

  const mobileSize = useMediaQuery(theme.breakpoints.down('xs'))

  const { location: { pathname } } = history

  const value = useMemo(() => {
    const index = findIndex(
      itens,
      ({ route }) => (`${ path }/${ route }` === pathname)|| path === pathname
    )

    return index >= 0 ? index : 0
  }, [itens, path, pathname])

  useEffect(() => {
    if (!value) {
      const firstTab = first(itens)
      const firstTabRoute = get(firstTab, 'route')

      if (pathname.match(firstTabRoute))
        return

      const firstTabUrl = `${ pathname }/${ firstTabRoute }`
      if (firstTab && firstTabUrl !== pathname) {
        history.replace(firstTabUrl)
      }
    }
  }, [history, itens, pathname, value])

  return (
    <div className={ classes.root }>
      <AppBar
        position="relative"
        color="inherit"
        classes={ {
          positionRelative: clsx(classes.appBar, {
            [classes.mobileAppBar]: mobileSize
          })
        } }
      >
        <Tabs
          value={ value }
          // variant={ mobileSize ? 'fullWidth' : 'scrollable' }
          // scrollButtons="on"
          indicatorColor="primary"
          aria-label="tabs"
        >
          {map(itens, ({ title, Icon, route }, index) => (
            <StyledTab
              key={ route }
              label={ title }
              icon={ Icon ? <Icon /> : undefined }
              onClick={ () => history.push(`${ path }/${ route }`) }
              { ...a11yProps(route, index) }
            />
          ))}
        </Tabs>
      </AppBar>
      <Switch>
        {map(itens, ({ Component, route, ComponentProps = {} }, index) => Component && (
          <Route
            key={ route }
            path={ `${ path }/${ route }` }
            exact
            render={ () => (
              <TabPanel
                key={ `${ route }-tabpanel` }
                id={ route }
                value={ value }
                index={ index }
                boxProps={ { style: { padding: '20px 0' } } }
              >
                <Component { ...ComponentProps } />
              </TabPanel>
            ) }
          />
        ))}
      </Switch>
    </div>
  )
}

TabsPanelRoutes.propTypes = {
  itens: PropTypes.arrayOf(PropTypes.shape({
    route: PropTypes.string.isRequired,
    title: PropTypes.string,
    Component: PropTypes.func,
    Icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }))
}

TabsPanelRoutes.defaultProps = {
  itens: []
}

export default TabsPanelRoutes
